import { useQuery } from '@tanstack/react-query';
import { RestEndpoints } from "../../../api/endpoints";
import { ReactQueryConfig } from "../../../config/react-query-config";
import { UserLeanConverter } from "../../../shared/domain/converter/user-lean.converter";
import { IUserLeanList } from "../../../shared/domain/user/user-lean";
import { IUserLeanListModel } from "../../../shared/models/user/user-lean.model";
import getInstance from "../../../utils/rest";
import { PomQueryKeys } from "../pom-query-keys";

const getPomMainContactsOfCurrentGroup = async (): Promise<IUserLeanList> => {
  const result = await getInstance().get<IUserLeanListModel>(RestEndpoints.PomMainContactsOfCurrentGroup);
  return UserLeanConverter.listToDomain(result.data.items);
};

export const useGetPomMainContactsOfCurrentGroupQuery = (enabled: boolean) => {
  return useQuery({
    queryKey: [PomQueryKeys.GetPomMainContactsOfCurrentGroup],
    queryFn: () => getPomMainContactsOfCurrentGroup(),
    staleTime: ReactQueryConfig.staleTime,
    enabled
  });
};
